import React from 'react';
import PropTypes from 'prop-types';

import {labels} from '../../../../../../../../util/utils';

import OutputText from '@ey/canvascoreservices/OutputText';

import ColorLabelTag from './ColorLabelTag';
import StyledTags from './StyledTags';

const TagList = ({tagsList, handleChange}) => {
	const keyContacts = {
		title: labels.keyContacts,
		tags: tagsList?.filter((tag) => tag.isCustom === false)
	};

	const customContacts = {
		title: labels.customTags,
		tags: tagsList?.filter((tag) => tag.isCustom === true)
	};

	const renderTags = ({title, tags}) => {
		return (
			<>
				<OutputText ellipsis title={title}>
					{title}
				</OutputText>
				<div className="list">
					{tags?.map((tag) => {
						const props = {
							key: tag.id,
							value: tagsList,
							name: tag.name,
							checked: tag?.checked,
							indeterminate: tag?.indeterminate,
							id: tag.id,
							handleChange,
							colorName: tag.color.toLowerCase()
						};
						return <ColorLabelTag {...props} />;
					})}
				</div>
			</>
		);
	};

	const hasCustomTags = customContacts?.tags?.length > 0;

	return (
		<StyledTags>
			{renderTags(keyContacts)}
			{hasCustomTags && renderTags(customContacts)}
		</StyledTags>
	);
};

TagList.propTypes = {
	tagsList: PropTypes.objectOf(PropTypes.any),
	handleChange: PropTypes.func.isRequired
};

export default TagList;
